import { createContext } from 'react';

export const VariantContext = createContext(null);
